import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    .icon-box-area {
        background: ${colors.bg2};
        padding-top: 50px;
        padding-bottom: 80px;

        .icon-box-heading {
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
        }

        .icon-box-heading h3 {
            color: ${colors.black1};
            font-weight: 600;
            text-transform: uppercase;
            margin-bottom: 37px;

            span {
                color: ${colors.green};
            }

            @media (max-width: 575px) {
                margin-bottom: 15px;
                font-size: 20px;
            }
        }
        
        .icon-box {
            background: ${colors.bg2} !important;
        }

        .full-icon-box {
            background: ${colors.bg2};
            position: relative;
            margin-top: 10px;

            .icon-box {
                position: relative;
                margin-bottom: 50px;
                left: 0;
                width: 100%;
                background: #fff;
                padding: 35px 20px 20px;
                z-index: 9;
                // box-shadow: 0 12px 25px rgba(0, 0, 0, 0.07);
                border-radius: 5px;

                .box-logo {
                    text-align: center;
                    margin-bottom: 10px;

                    img {
                        height: auto;
                    }
                    
                    @media (max-width: 768px) {
                        img {
                            width: 300px;
                        }
                    }
                    
                    @media (min-width: 769px) {
                        img {
                            width: 400px;
                        }
                    }
                }

                .box-text {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    column-gap: 20px;
                    margin-top: 10px;
                    margin-left: 20px;
                }

                @media (max-width: 767px) {
                    .box-text {
                        margin-top: 0px;
                    }
                }

                .flow-item {
                    margin-bottom: 30px;
                }

                .flow-heading {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                }

                .flow-number {
                    color: ${colors.black1};
                    font-weight: 600;
                    text-transform: uppercase;
                    font-size: 18px;
                    margin-right: 10px;
                }

                .flow-title {
                    color: ${colors.black1};
                    font-weight: 600;
                    font-size: 18px;
                    text-justify: distribute;
                }

                @media (max-width: 767px) {
                    .flow-number,
                    .flow-title {
                      font-size: 14px;
                }

                .flow-desc {
                    color: ${colors.black1};
                    font-weight: 600;
                    text-justify: distribute;
                }
            }
        }
    }
`;
